import React from 'react';
import PropTypes from 'prop-types';
import {
  Checkbox, Divider, Form, Input
} from 'antd';
import { FormWrapper } from 'components/Page';

const FormItem = Form.Item;

const mapPropsToFields = (props) => {
  const { dataSource } = props;
  const { active, name } = dataSource;

  return {
    active: Form.createFormField({ value: active }),
    name: Form.createFormField({ value: name })
  };
};

const onFieldsChange = (props, fields) => {
  const { onFieldsChange: dispatchOnFieldsChange } = props;
  if (dispatchOnFieldsChange) {
    dispatchOnFieldsChange(fields);
  }
};

const onValuesChange = (props, values) => {
  const { onValuesChange: dispatchOnValuesChange } = props;
  if (dispatchOnValuesChange) {
    dispatchOnValuesChange(values);
  }
};

const FormInput = ({
  canAdmin, checkboxFormItemLayout, dataSource, inputFormItemLayout, form
}) => {
  const { getFieldDecorator } = form;
  const {
    active, name, is_integration_managed, sap_code
  } = dataSource;
  const readonly = !canAdmin || is_integration_managed;
  return (
    <Form>
      <FormItem {...inputFormItemLayout} label="Name">
        {
          getFieldDecorator('name', {
            initialValue: name,
            rules: [{
              required: true,
              message: 'Please enter the Leave Status name.'
            }]
          })(<Input disabled={readonly} />)
        }
      </FormItem>
      <FormItem {...checkboxFormItemLayout}>
        {
          getFieldDecorator('active', {
            initialValue: active,
            valuePropName: 'checked'
          })(
            <Checkbox disabled={readonly}>
              Active
            </Checkbox>
          )
        }
      </FormItem>
      <Divider />
      <FormItem {...inputFormItemLayout} label="SAP Code">
        {
          getFieldDecorator('sap_code', {
            initialValue: sap_code
          })(<Input disabled />)
        }
      </FormItem>
      <FormItem {...checkboxFormItemLayout}>
        {
          getFieldDecorator('is_integration_managed', {
            initialValue: is_integration_managed,
            valuePropName: 'checked'
          })(
            <Checkbox disabled>
              Managed in 1SAP
            </Checkbox>
          )
        }
      </FormItem>
    </Form>
  );
};

FormInput.propTypes = {
  canAdmin: PropTypes.bool,
  checkboxFormItemLayout: PropTypes.object,
  dataSource: PropTypes.object,
  form: PropTypes.object,
  inputFormItemLayout: PropTypes.object,
  onFieldsChange: PropTypes.func,
  onValuesChange: PropTypes.func
};

FormInput.defaultProps = {
  canAdmin: false,
  checkboxFormItemLayout: {},
  dataSource: {},
  form: {},
  inputFormItemLayout: {},
  onFieldsChange() {
  },
  onValuesChange() {
  }
};

const LeaveTypeFormInput = FormWrapper(Form.create({
  mapPropsToFields,
  onFieldsChange,
  onValuesChange
})(FormInput));

export default LeaveTypeFormInput;
